import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { RaceSummaryCaption } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummaryNew.style';
import { withConfig } from 'src/withConfig';

interface RaceSummaryResultsCaptionPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceSummaryResultsCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.small};
            border: none;
        `;
    }
    return css`
        border-style: solid;
        border-color: ${theme.star.raceSummary.borderColor};
        border-width: 0 0 1px 0;
        @media ${theme.star.mediaQuery.tablet} {
            border-width: 0 0 1px 1px;
        }
    `;
};

export const RaceSummaryResultsCaption = withConfig(theme => styled(RaceSummaryCaption, { label: 'RaceSummaryResultsCaption' })<RaceSummaryResultsCaptionPropsType>`
    ${({ variant }): SerializedStyles => setRaceSummaryResultsCaption(variant, theme)};
    height: 24px;
`);

export const ResultsTableMessage = withConfig(theme => styled('div', { label: 'ResultsTableMessage' })`
    background-color: ${theme.star.raceCard.results.bgColor};
    color: ${theme.star.raceCard.results.txtColor};
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.5;
    padding: 12px 8px;
`);

interface RaceResultsRowWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceResultsRowWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.small};
        `;
    }
    return css``;
};

export const RaceResultsRowWrapper = withConfig(theme => styled('div', { label: 'RaceResultsRowWrapper' })<RaceResultsRowWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setRaceResultsRowWrapper(variant, theme)};
`);

interface RaceResultsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceResultsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
            overflow: hidden;
            padding: ${theme.star.padding.medium};
            background-color: ${theme.star.raceCard.results.bgColorTertiary};
            display: flex;
            flex-flow: column nowrap;
            gap: 8px;
        `;
    }
    return css``;
};

export const RaceResultsWrapper = withConfig(theme => styled('div', { label: 'RaceResultsWrapper' })<RaceResultsWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setRaceResultsWrapper(variant, theme)};
`);
